export const SET_STORIES = 'SET_STORIES'

export const SHOW_PROACTIVE_MSG = 'SHOW_PROACTIVE_MSG'

export const SET_SHOW_STORIES = 'SET_SHOW_STORIES'

export const SET_SELECTED_STORIES = 'SET_SELECTED_STORIES'

export const SET_STORIES_LIST = 'SET_STORIES_LIST'

export const ENABLE_VUEPER_STORIES = 'ENABLE_VUEPER_STORIES'

export const DISABLE_VUEPER_STORIES = 'DISABLE_VUEPER_STORIES'

export const MANUAL_CLOSE_PROACTIVE_MESSAGE = 'MANUAL_CLOSE_PROACTIVE_MESSAGE'
